import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  Typography,
  Paper,
  Button,
  CircularProgress,
  Avatar,
} from "@mui/material";
import { Box } from "@mui/system";
import { Row, Col } from "react-bootstrap";
import { FaPrint } from "react-icons/fa";
import { MdOutlineWatchLater } from "react-icons/md";
import { useReactToPrint } from "react-to-print";
import { getAssetDetails } from "../../../../Redux/Actions/assetActions";
import moment from "moment";
import Header from "../../../../Components/Header/Header";
import ProfilePic from "../../../../Asssets/Images/profile.png";
import { useStyle } from "../../../HR/Pages/LeaveManagement/leaveStyles";

const AssetDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const printRef = useRef();
  const classes = useStyle();
  const { asset, loading } = useSelector((state) => state.asset.assetDetails);

  useEffect(() => {
    dispatch(getAssetDetails(id));
  }, [dispatch, id]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // Hide elements in print
  const printStyles = `
    @media print {
      .no-print { display: none !important; }
      .print-table-row {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        margin-bottom: 0 !important;
      }
      .print-table-col {
        flex: 1 1 0;
        padding: 0 8px;
        min-width: 0;
        box-sizing: border-box;
      }
      .print-table-label {
        font-weight: bold !important;
        font-size: 16px !important;
        color: #253766 !important;
        margin-bottom: 2px !important;
      }
      .print-table-value {
        font-size: 15px !important;
        color: #222 !important;
      }
      .print-table-row + .print-table-row {
        margin-top: 8px !important;
      }
    }
  `;

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="page_responsive">
      <Header title="Asset Details" />
      {/* Print button at the top */}
      <div className="d-flex justify-content-end mx-4 mb-3 mt-3">
        <Button
          variant="outlined"
          onClick={handlePrint}
          startIcon={<FaPrint />}
        >
          Print Asset Details
        </Button>
      </div>
      <div ref={printRef}>
        <style>{printStyles}</style>
        <Row className="justify-content-center">
          {/* Left Column: Details */}
          <Col md={7}>
            <Box className="my-2 ms-4">
              <Paper className={classes.sectionsContainer}>
                <Box className={classes.sectionHeader}>
                  Asset Details - {asset?.tag || "N/A"}
                </Box>
                <Box className="mx-3">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    className="my-3"
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                    </div>

                    <div className="created_at_container">
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <MdOutlineWatchLater
                          style={{
                            fontSize: "23px",
                            marginRight: "3px",
                            color: "#0097d9",
                          }}
                        />{" "}
                        <div>
                          <h6
                            className="mb-1"
                            style={{ color: "#0097d9", fontWeight: "500" }}
                          >
                            Created At{" "}
                          </h6>
                          <h6 style={{ fontSize: "14px" }}>
                            {moment(asset?.createdAt).format("DD-MM-YYYY")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Box>

                <Box className={`mx-3 ${classes.leaveDetails}`}>
                  {/* Tag on first line */}
                  <Row className="mt-4 mb-2">
                    <Col md={12}>
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                          display: "inline",
                        }}
                      >
                        Tag:
                      </div>
                      <span
                        style={{
                          fontWeight: 400,
                          fontSize: 16,
                          color: "#222",
                          marginLeft: 8,
                        }}
                      >
                        {asset?.tag || "N/A"}
                      </span>
                    </Col>
                  </Row>

                  {/* 2 fields per line */}
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Category
                      </div>
                      <div className="print-table-value">
                        {asset?.category?.name || "-"}
                      </div>
                    </Col>
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Brand
                      </div>
                      <div className="print-table-value">
                        {asset?.brand || "-"}
                      </div>
                    </Col>
                  </Row>
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Model
                      </div>
                      <div className="print-table-value">
                        {asset?.model || "-"}
                      </div>
                    </Col>
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Condition
                      </div>
                      <div className="print-table-value">
                        {asset?.condition
                          ? asset.condition.charAt(0).toUpperCase() +
                            asset.condition.slice(1)
                          : "-"}
                      </div>
                    </Col>
                  </Row>
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Date of Purchase
                      </div>
                      <div className="print-table-value">
                        {asset?.date_of_purchase
                          ? moment(asset.date_of_purchase).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    </Col>
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Date of Warranty
                      </div>
                      <div className="print-table-value">
                        {asset?.date_of_warranty
                          ? moment(asset.date_of_warranty).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    </Col>
                  </Row>
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Price
                      </div>
                      <div className="print-table-value">
                        {asset?.price
                          ? `Rs. ${asset.price.toLocaleString()}`
                          : "-"}
                      </div>
                    </Col>
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Status
                      </div>
                      <div className="print-table-value">
                        {asset?.availibility_status
                          ?.split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ") || "-"}
                      </div>
                    </Col>
                  </Row>

                  {/* Issue Status*/}
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Issued To
                      </div>
                      <div className="print-table-value">
                        {asset?.issued_to
                          ? asset.issued_to.full_name
                          : "Not Issued"}
                      </div>
                    </Col>
                    { asset?.issued_to && 
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Issued Date
                      </div>
                      <div className="print-table-value">
                        {moment(asset.issue_date).format("DD-MM-YYYY")}
                      </div>
                    </Col>
                    }
                  </Row>

                  {/* Last Issued */}
                  <Row className="my-3 print-table-row">
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Last Issued To
                      </div>
                      <div className="print-table-value">
                        {asset?.last_issued_to
                          ? asset.last_issued_to.full_name
                          : "-"}
                      </div>
                    </Col>
                    { asset?.last_issued_to && 
                    <Col md={6} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Last Recall Date
                      </div>
                      <div className="print-table-value">
                        {moment(asset.return_date).format("DD-MM-YYYY")}
                      </div>
                    </Col>
                    }
                  </Row>

                  {/* Asset Note on its own line */}
                   <Row className="my-3 print-table-row">
                    <Col md={12} className="print-table-col">
                      <div
                        className="print-table-label"
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          color: "#253766",
                        }}
                      >
                        Note
                      </div>
                      <div className="print-table-value">
                        {asset?.notes || "-"}
                      </div>
                    </Col>
                  </Row>
                </Box>
              </Paper>
            </Box>
          </Col>

          {/* Right Column: Documents */}
          <Col md={5}>
            <Box className="my-2 me-4">
              <Paper className={classes.sectionsContainer + " no-print"}>
                <Box className={classes.sectionHeader}>Documents</Box>
                <Row>
                  {asset?.asset_docs && asset.asset_docs.length > 0 ? (
                    asset.asset_docs.map((doc) => (
                      <Col
                        md={6}
                        className="d-flex justify-content-center"
                        key={doc._id}
                      >
                        <Box className={classes.documents_container}>
                          <Box
                            sx={{
                              display: "flex",
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            <a
                              href={doc.fileName}
                              target="_blank"
                              style={{
                                width: "100%",
                                height: "200px",
                                position: "absolute",
                                top: 0,
                                left: 0,
                              }}
                            />
                            {doc.fileName.includes(".pdf") ? (
                              <iframe
                                src={doc.fileName}
                                width="100%"
                                height="100px"
                              />
                            ) : (
                              (doc.fileName.includes(".png") ||
                                doc.fileName.includes(".jpg") ||
                                doc.fileName.includes(".jpeg")) && (
                                <img
                                  src={doc.fileName}
                                  style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    height: "100px",
                                  }}
                                />
                              )
                            )}
                          </Box>
                        </Box>
                      </Col>
                    ))
                  ) : (
                    <Typography variant="h6" className="text-center mt-3">
                      No Documents submitted!
                    </Typography>
                  )}
                </Row>
              </Paper>
            </Box>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AssetDetails;
